<template>
  <div>
    <div
      class="payment-methods"
      :class="checkTaxInvoice ? 'summary-height-tax' : 'summary-height'"
    >
      <div class="d-none" v-html="stringHtml"></div>
      <div class="d-flex align-items-center mt-3">
        <img src="@/assets/images/big_tick.svg" width="50" alt />
        <h5 class="text-success fw-normal mt-1 ml-3">
          <span v-if="!layByStatus && !refundMode && !checkOnAccountSale.show"
            >Payment complete!</span
          >
          <span v-if="layByStatus && !refundMode && !checkOnAccountSale.show"
            >Layby Complete!</span
          >
          <span v-if="refundMode && !checkOnAccountSale.show"
            >Return Processed Successfully!</span
          >
          <span v-if="checkOnAccountSale.show && !refundMode && !layByStatus"
            >On-account sale successful!</span
          >
        </h5>
      </div>
      <div class="clearfix"></div>
      <h6 class="mt-5 fw-normal">Invoice Details</h6>
      <hr class="my-2" />
      <b-row>
        <b-col md="6" v-if="!layByStatus">
          <label for>Invoice Number</label>
          <p v-text="state.billing.billing.invoice.data.invoice_id" />
        </b-col>
        <b-col
          md="4"
          v-if="
            layByStatus == true || state.billing.billing.billing_mode == 'order'
          "
        >
          <label for>Order Number</label>
          <p v-text="state.billing.billing.invoice.data.order_id" />
        </b-col>
        <b-col md="6">
          <label for>Date / Time</label>
          <p>
            {{
              state.billing.billing.invoice.data.created_at
                | moment("DD MMMM YYYY h:mm A")
            }}
          </p>
        </b-col>
        <!-- <b-col md="4">
          <label>Store</label>
          <p>NA</p>
        </b-col>-->
        <b-col md="4">
          <!-- <label>Assigned Salesperson</label>
          <p>{{state.user.first_name}}</p>-->
        </b-col>
        <b-col md="12" v-if="state.billing.billing.remark != ''">
          <label>Bill Remarks</label>
          <p v-text="state.billing.billing.remark" />
        </b-col>
      </b-row>
      <h6 class="mt-3 fw-normal">Customer Information</h6>
      <hr class="my-2" />
      <b-row class="mt-2">
        <b-col md="6">
          <label>Customer Phone Number</label>
          <p v-text="state.billing.billing.invoice.data.mobile" />
        </b-col>
        <b-col md="6">
          <label>Customer Name</label>
          <p v-text="state.billing.billing.invoice.data.customer_name" />
        </b-col>
      </b-row>

      <h6 class="mt-3 fw-normal">Payment Summary</h6>
      <hr class="my-2" />
      <b-row class="mt-2">
        <b-col md="6">
          <label>Total Amount</label>
          <p>
            {{ currencySymbol }}
            {{
              formatAmount(state.billing.billing.invoice.summary.order_total)
            }}
          </p>
        </b-col>
        <b-col md="6" v-if="!checkOnAccountSale.show">
          <label>
            {{
              layByStatus == true &&
              !refundMode &&
              state.billing.billing.billing_mode == "normal"
                ? "Lay-by Amount"
                : refundMode
                ? "Total Refund Amount"
                : "Total Amount Paid"
            }}
          </label>
          <p v-text="currencySymbol + formatAmount(amountPaid)" />
        </b-col>
        <b-col md="4" v-if="layByStatus || checkOnAccountSale.show">
          <label style="color: #ff6666 !important;">Amount Due</label>
          <p>
            {{ currencySymbol }}
            {{
              checkOnAccountSale.show
                ? formatAmount(checkOnAccountSale.value)
                : formatAmount(state.billing.billing.invoice.summary.amount_due)
            }}
          </p>
        </b-col>
      </b-row>
    </div>
    <div class="customer-info">
      <b-row>
        <b-col md="6" v-if="layByStatus == false" class="pr-1">
          <b-button
            class="mt-2"
            block
            variant="primary"
            id="print-invoice-btn"
            @click="checkForPrint"
            >Print Invoice
            <span
              v-if="state.billing.bill_print_limit.enable"
              v-text="
                `(${state.billing.bill_print_limit.limit -
                  state.billing.bill_print_limit.count})`
              "
          /></b-button>
          <b-modal
            id="print-confirmation-modal"
            ref="print-confirmation-modal"
            centered
            hide-footer
            hide-header
            no-close-on-backdrop
            no-close-on-esc
            size="sm"
          >
            <header><h6>E-Invoice not generated</h6></header>
            <p>
              Are you sure you wish to print invoice without the E-Invoice
              information?
            </p>
            <div class="d-flex mt-2">
              <b-button
                class="mr-1"
                block
                variant="outline-primary"
                @click="$refs['print-confirmation-modal'].hide()"
                >Close</b-button
              >
              <b-button
                class="ml-1"
                block
                variant="primary"
                @click="
                  openPrintModal(), $refs['print-confirmation-modal'].hide()
                "
                >Continue</b-button
              >
            </div>
          </b-modal>
        </b-col>

        <b-col class="pl-1" md="6">
          <b-button
            variant="primary"
            class="mt-4 mt-md-2"
            block
            @click="openShareModal = true"
            :disabled="
              layByStatus ||
                state.system.isOffline ||
                refundMode ||
                (!shareInvoiceVia.sms && !shareInvoiceVia.email)
            "
            v-if="!layByStatus"
            id="share-invoice-btn"
          >
            Share Invoice
          </b-button>
        </b-col>

        <!-- <b-col md="6" class="pl-1">
          <b-button
            variant="primary"
            block
            class="mt-4 mt-md-2"
            @click="newBill"
            id="new-bill-btn"
          >
            New Bill
          </b-button>
        </b-col> -->
        <b-col md="3" v-if="layByStatus">
          <b-button
            class="mt-4 mt-md-2"
            variant="primary"
            block
            @click="openDepositModal"
            v-if="
              this.state.billing.billing.invoice.summary.total_payable != 0 &&
                state.billing.billing.billing_mode == 'normal'
            "
            id="deposit-btn"
          >
            Deposit
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          md="12"
          v-if="
            !this.state.system.isOffline &&
              state.billing.billing.invoice.data.hasOwnProperty('cust_gstin') &&
              JSON.parse(this.state.system.settings.store.einvoice_enable) &&
              state.billing.billing.invoice.data != null
          "
        >
          <b-button
            variant="primary"
            block
            class="mt-4 mt-md-2"
            @click="eInvoiceHandler"
            id="generate-einvoice"
            v-if="eInvoiceStatus != 'success'"
          >
            <span v-if="eInvoiceStatus == ''"
              ><b-spinner small class="mr-1" /> Generating E-Invoice</span
            >
            <span v-if="eInvoiceStatus == 'fail'">Generate E-Invoice</span>
            <span v-if="eInvoiceStatus == 'success'">E-Invoice Generated</span>
          </b-button>

          <b-button
            variant="primary"
            block
            class="mt-4 mt-md-2"
            @click="helper.downloadEinvoive()"
            v-if="eInvoiceStatus == 'success'"
            id="download-einvoice"
          >
            Download E-Invoice
          </b-button>

          <b-modal
            ref="einvoice-modal"
            id="einvoice-modal"
            size="sm"
            hide-footer
            hide-header
            centered
            no-close-on-esc
            no-close-on-backdrop
            @hide="clearTimer"
          >
            <header>
              <h6 v-if="eInvoiceStatus == ''">Generating E-Invoice</h6>
              <h6 v-if="eInvoiceStatus == 'fail'">
                <img src="../assets/images/alert.svg" class="mr-1" />
                E-Invoice Generation Failed
              </h6>
              <h6 v-if="eInvoiceStatus == 'success'">
                <img src="../assets/images/success.svg" class="mr-1" />
                E-Invoice Generated
              </h6>
            </header>
            <!-- <b-row class="mt-4 mb-3 text-muted">
              <b-col md="2"
                ><img src="../assets/images/success.svg" class="mr-1"
              /></b-col>
              <b-col md="10" class="pl-0">First process being executed</b-col>
            </b-row> -->
            <!-- <b-row class="mb-3 text-muted">
              <b-col md="2"
                ><img src="../assets/images/success.svg" class="mr-1"
              /></b-col>
              <b-col md="10" class="pl-0">Second process to be executed</b-col>
            </b-row> -->
            <b-row class="mt-4" v-if="eInvoiceStatus == ''">
              <b-col md="2">
                <b-spinner small class="mr-1" />
                <!-- <img
                  src="../assets/images/success.svg"
                  class="mr-1"
                  v-if="eInvoiceStatus == 'success'"
                />
                <img
                  src="../assets/images/alert.svg"
                  class="mr-1"
                  v-if="eInvoiceStatus == 'fail'"
                /> -->
              </b-col>
              <b-col md="10" class="pl-0">
                <span>Processing E-Invoice</span>
                <!-- <span class="text-danger" v-if="eInvoiceStatus == 'fail'"
                  >E-invoice generation failed</span
                >
                <span v-if="eInvoiceStatus == 'success'"
                  >E-Invoice Generated</span
                > -->
              </b-col>
            </b-row>
            <b-row v-if="eInvoiceStatus != ''">
              <b-col md="12">
                <p class="mb-0 mt-4" v-if="eInvoiceStatus == 'fail'">
                  The E-invoice could not be generated due to a network error.
                  Please try again in some time.
                </p>
                <p class="mb-0 mt-4" v-if="eInvoiceStatus == 'success'">
                  E-Invoice generated successfully.
                </p>
              </b-col>
            </b-row>
            <br />
            <div class="d-flex mt-2">
              <b-button
                block
                variant="primary"
                @click="$refs['einvoice-modal'].hide()"
                v-if="eInvoiceStatus == '' || eInvoiceStatus == 'success'"
                id="hide-einvoice-modal"
                >Hide Popup
                <span v-if="eInvoiceStatus == 'success'"
                  >(<span id="timer">10</span>s)</span
                ></b-button
              >
              <b-button
                class="mr-1"
                block
                variant="outline-primary"
                @click="$refs['einvoice-modal'].hide()"
                v-if="eInvoiceStatus == 'fail'"
                id="dismiss-einvoice-modal"
                >Dismiss</b-button
              >
              <b-button
                class="ml-1"
                block
                variant="primary"
                @click="generateEinvoice"
                v-if="eInvoiceStatus == 'fail'"
                id="retry-einvoice-modal"
                >Retry</b-button
              >
            </div>
          </b-modal>
        </b-col>
      </b-row>
    </div>
    <!-- Cash Modal -->

    <b-modal
      ref="print-invoice-modal"
      hide-header
      hide-footer
      centered
      @hidden="hidePrintModal"
      :size="printSize == 'A4' ? 'xl' : ''"
    >
      <div class="modal-head" style="border-bottom: 1px #c0c0c0 solid;">
        <b-row class="pb-3 print_box">
          <b-col>
            <h3 class="modal-title">Invoice</h3>
          </b-col>
          <b-col>
            <b-button
              variant="primary"
              class="float-right"
              id="print-invoice"
              @click="printInvoice"
              >Print</b-button
            >
            <b-button
              style="margin-right:10px;"
              class="float-right"
              @click="hidePrintModal"
              id="close-print-modal"
              >Close</b-button
            >
          </b-col>
        </b-row>
      </div>
      <div id="cool">
        <print-box :data="html" :print_type="'print'" />
      </div>
    </b-modal>
    <b-modal
      ref="deposit-amount"
      title="Lay-By"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="sm"
    >
      <b-form @submit.prevent>
        <b-form-row>
          <b-col md="6" style="color: rgb(255, 102, 102) !important;"
            >Amount Due</b-col
          >
          <b-col offset="2" class="float-right">
            <span
              v-text="
                currencySymbol +
                  formatAmount(state.billing.billing.invoice.summary.amount_due)
              "
            />
          </b-col>
        </b-form-row>
        <hr />
        <b-form-row>
          <b-col md="12">
            <label id="label-amt-deposit">Enter Amount to deposit</label>
            <b-form-input
              v-model="layby_amt_due"
              placeholder="Amount Due"
              type="number"
              id="input-amt-deposit"
              autofocus
              autocomplete="off"
              @click="layby_amt_due = ''"
            />
          </b-col>
          <!-- <b-col md="12" class="mt-3">
            <label>Remarks</label>
            <b-form-textarea v-model="remarks" placeholder="Please enter remark" type="text"></b-form-textarea>
          </b-col>-->
        </b-form-row>
        <br />
        <b-form-row>
          <b-col>
            <b-button
              variant="primary"
              block
              type="submit"
              id="save-deposit"
              class="w-50 float-right px-2"
              :disabled="
                this.layby_amt_due == '' ||
                  this.layby_amt_due >
                    this.state.billing.billing.invoice.summary.total_payable
              "
              @click="SaveDepositAmt"
            >
              <div v-if="!$loading">Continue</div>
              <b-spinner small v-if="$loading" />
            </b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </b-modal>

    <share-invoice-modal
      :open="openShareModal"
      :custMob="state.billing.billing.invoice.data.mobile"
      :custEmail="state.billing.billing.invoice.data.email"
      :invoiceNo="state.billing.billing.invoice.data.invoice_id"
      @close-modal-share="openShareModal = false"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import * as msg from "../message";
import PrintBox from "./PrintBox";
import qz from "../printer";
import * as helper from "../helper";
import ShareInvoiceModal from "./ShareInvoiceModal";

export default {
  name: "payment-done",
  components: {
    PrintBox,
    ShareInvoiceModal,
  },
  props: ["data"],
  data() {
    return {
      Title: "Product Name & Description (Barcode)",
      html: "",
      changeData: customData,
      invoiceBtnDisabled: false,
      laybyfromorder: false,
      stringHtml: "",
      layby_amt_due: "",
      email: "",
      diff: 0,
      form: {
        mobile: "",
      },
      eInvoiceStatus: "",
      eInvoiceTimer: null,
      openShareModal: false,
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    layByStatus() {
      if (
        parseFloat(this.state.billing.billing.invoice.summary.amount_due) != 0
      ) {
        return true;
      } else {
        return false;
      }
    },

    printSize() {
      let size = 80;
      this.state.system.settings.print.map((item) => {
        if (item.name == "bill_print") {
          size = item.width;
        }
      });
      return size;
    },
    refundMode() {
      let check = false;
      if (this.state.billing.billing.refund_mode) {
        check = true;
      }
      return check;
    },
    checkOnAccountSale() {
      let check = { show: false, value: "" };
      this.state.billing.billing.invoice.summary.summary.map((item) => {
        if (item.name == "debit_voucher")
          check = { show: true, value: item.value };
      });
      return check;
    },
    helper() {
      return helper;
    },
    checkTaxInvoice() {
      let temp = false;
      if (
        !this.state.system.isOffline &&
        this.state.billing.billing.invoice.data.hasOwnProperty("cust_gstin") &&
        this.state.billing.billing.invoice.data != null &&
        JSON.parse(this.state.system.settings.store.einvoice_enable)
      )
        temp = true;
      return temp;
    },
    amountPaid() {
      return this.refundMode
        ? parseFloat(
            this.state.billing.billing.invoice.summary.total_refund
          ).toFixed(2)
        : parseFloat(
            this.state.billing.billing.invoice.summary.amount_paid
          ).toFixed(2);
    },
    billLogo() {
      return this.$store.getters["system/billLogo"];
    },
    qrCode() {
      return this.$store.getters["system/qrCode"];
    },
    shareInvoiceVia() {
      let temp = { email: false, sms: false };
      temp.email =
        this.state.system.settings.share_invoice_via.allow_via_email.status == 1
          ? true
          : false;
      temp.sms =
        this.state.system.settings.share_invoice_via.allow_via_sms.status == 1
          ? true
          : false;
      return temp;
    },
    printBtn: {
      set(val) {
        this.$store.commit("billing/billReprintSetter", {
          type: "count",
          value: (this.state.billing.bill_print_limit.count += val),
        });
      },
      get() {
        return this.state.billing.bill_print_limit.count;
      },
    },
  },
  beforeDestroy() {
    this.$store.commit("billing/clearInvoiceDetails");
  },
  watch: {
    changeData: {
      handler(val) {
        let self = this;
        console.log("In Data");
        if (val.data.type == "print_invoice") {
          if (val.data.status == "success") {
            self.invoiceBtnDisabled = true;
            console.log("Change Data");
          } else {
            // console.log("Printer Not Working");
            // let alertData = {
            //   message: msg.PRINT_NOT_WORKING,
            //   type: "danger"
            // };
            // this.$showAlert = true;
            // this.$store.commit("showAlert", alertData);
          }
        }
        if (val.data.type == "session_timeout") {
          console.log("Login Expire");
          let errorData = {
            msg: msg.LOGIN_REDIRECT,
            btntext: "Login",
            type: "logout",
          };
          this.$store.commit("notifications/showMessage", errorData);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchInfo();
    if (this.state.system.isOffline) this.offlinePrint();
    else if (
      !this.state.system.isOffline &&
      this.state.billing.billing.invoice.data.hasOwnProperty("cust_gstin") &&
      this.state.billing.billing.invoice.data != null &&
      JSON.parse(this.state.system.settings.store.einvoice_enable)
    )
      this.generateEinvoice();
    this.$store.commit("billing/setInvoiceDetails", {
      invoice_no: this.state.billing.billing.invoice.data.invoice_id,
      amount: this.amountPaid,
    });
    if (this.state.billing.auto_print == 1) {
      this.checkForPrint();
      this.$store.commit("billing/printMode", 0);
    }
  },
  methods: {
    fetchInfo() {
      this.email = this.state.billing.billing.invoice.data.email;
      this.form.mobile = this.state.billing.billing.invoice.data.mobile;
      let manuName = "";
      this.state.system.settings.print.map((setting) => {
        if (setting.display_name == "Bill Print") {
          if (setting.status == 1 && setting.width == 80)
            manuName = "SUNMI|T1-G";
          else if (setting.status == 1 && setting.width == 58)
            manuName = "basewin|P1000S";
        }
        // console.log(manuName);
      });
      if (
        this.layByStatus == false &&
        this.state.billing.billing.invoice.summary.total_payable == 0
      ) {
        if (this.state.system.printer != "") {
          manuName = this.state.system.printer;
        }
        let invoiceData = {
          order_id: this.state.billing.billing.invoice.data.invoice_id,
          manufacturer_name: manuName,
          url: "get-print-receipt",
        };
        if (this.state.giftVoucher.isGvSale) invoiceData.print_for = "GV";
        let postData = Object.assign(
          invoiceData,
          this.essentialsData,
          this.customerData
        );
        axios.post(postData.url, postData).then((res) => {
          if (this.printSize != "A4") {
            this.stringHtml = res.data.print_data
              .replace(
                /<size=24>|<bold>|<\/bold>|<\/size>|<normal>|<\/normal>/gi,
                ""
              )
              .replace(/<center>/gi, "<div class='cool-center'>")
              .replace(/<left>/gi, "<div class='cool-left'>")
              .replace(/<right>/gi, "<div class='cool-right'>")
              .replace(/<text>/gi, "<span>")
              .replace(/<\/text>/gi, "</span>")
              .replace(/<\/center>|<\/left>|<\/right>/gi, "</div>");
            this.stringHtml =
              "<div class='webpos-print'>" + this.stringHtml + "</div>";
          } else {
            this.$store.commit("billing/setPrintData", res.data);
            this.stringHtml = res.data.html;

            this.stringHtml =
              "<div class='webpos-print'><div>" +
              this.stringHtml +
              "</div></div>";
          }
        });
      }
    },
    offlinePrint() {
      let data = [];
      let invoiceData = {
        order_id: this.state.billing.billing.invoice.data.invoice_id,
        // manufacturer_name: manuName,
        url: "get-print-receipt",
      };
      if (this.state.giftVoucher.isGvSale) invoiceData.print_for = "GV";
      let postData = Object.assign(
        invoiceData,
        this.essentialsData,
        this.customerData
      );
      axios.post(postData.url, postData).then((res) => {
        data = res.data.print_data;
        this.stringHtml = data;
        this.stringHtml =
          "<div class='webpos-print'>" + this.stringHtml + "</div>";
        this.$store.commit("billing/setPrintData80", this.stringHtml);
      });
    },
    // checkMobileNumber: function() {
    //   this.mobile = "";
    // },
    newBill() {
      this.$store.dispatch("billing/newBill");
      this.$router.push("billing");
    },
    openPrintModal() {
      // this.$loading = true;
      if (typeof Android !== "undefined" && Android !== null) {
        let invoiceData = {
          order_id: this.state.billing.billing.invoice.data.invoice_id,
          manufacturer_name: this.state.system.device_name,
          url: "get-print-receipt",
        };
        if (this.state.giftVoucher.isGvSale) invoiceData.print_for = "GV";
        let data = Object.assign(
          invoiceData,
          this.essentialsData,
          this.customerData
        );
        axios.post(data.url, data).then((res) => {
          let postData = { type: "print_invoice", data: res.data.print_data };
          returnValue(postData);
        });
      } else {
        if (this.state.system.printer != "" && qz.websocket.isActive()) {
          this.getPrinterList();
        } else {
          this.html =
            this.billLogo.data[0].data != "" && this.printSize != "A4"
              ? this.billLogo.img +
                this.state.billing.billing.invoice.data.html_data
              : this.state.billing.billing.invoice.data.html_data;
          this.html =
            this.qrCode.print && this.printSize != "A4"
              ? this.html + this.qrCode.qrImg
              : this.html;
          this.$refs["print-invoice-modal"].show();
        }
      }
    },
    hidePrintModal() {
      this.$loading = false;
      this.$refs["print-invoice-modal"].hide();
      this.$loading = false;
    },
    printInvoice() {
      let prtContent = document.getElementById("cool");
      // console.log(prtContent.innerHTML);
      let WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write("<html><head><title>Print Bill</title>");
      if (this.printSize == "A4") {
        WinPrint.document.write(
          this.state.billing.billing.invoice.data.html_data.style
        );
      } else {
        WinPrint.document.write(
          "<style>table{text-align:center}img{width: 150px; height: auto;}</style>"
        );
      }
      WinPrint.document.write("</head><body>");
      WinPrint.document.write("<div>");
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.write("</div>");
      WinPrint.document.write("</body></html>");
      // WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    },
    getPrinterList() {
      // this.stringHtml = res.data.print_data
      //   .replace(
      //     /<size=24>|<bold>|<\/bold>|<\/size>|<normal>|<\/normal>/gi,
      //     ""
      //   )
      //   .replace(/<center>/gi, "<div class='cool-center'>")
      //   .replace(/<left>/gi, "<div class='cool-left'>")
      //   .replace(/<right>/gi, "<div class='cool-right'>")
      //   .replace(/<text>/gi, "<span>")
      //   .replace(/<\/text>/gi, "</span>")
      //   .replace(/<\/center>|<\/left>|<\/right>/gi, "</div>");
      // this.stringHtml =
      //   "<div class='webpos-print'>" + this.stringHtml + "</div>";

      this.$nextTick(() => {
        let billData = [];
        let data = document.querySelectorAll(".webpos-print div");
        if (
          this.state.system.isOffline == true &&
          this.state.system.settings.vendor_app_menu.hasOwnProperty(
            "offline"
          ) &&
          this.state.system.settings.vendor_app_menu.offline.status == 1
        ) {
          for (let i = 0; i < data.length; i++) {
            let tempData = data[i].childNodes;
            for (let j = 0; j < tempData.length; j++) {
              // for (var k = 0; k < tempData[j].rows.length; k++) {
              // console.log(tempData[j].rows[k].innerText);
              billData.push({
                content: tempData[j].innerText,
                size: tempData[j].innerText.length,
              });
              // }
            }
          }
        } else {
          for (let i = 0; i < data.length; i++) {
            let tempData = data[i].childNodes;
            // if (data[i].className == "cool-center") {
            //   let centerAlign = "\x1B" + "\x40";
            //   billData.push({
            //     content: centerAlign,
            //     size: 1
            //   });
            // }
            // if (data[i].className == "cool-left") {
            //   let leftAlign = "\x1B" + "\x61" + "\x31";
            //   billData.push({
            //     content: leftAlign,
            //     size: 1
            //   });
            // }

            for (let j = 0; j < tempData.length; j++) {
              billData.push({
                content: tempData[j].textContent,
                size: tempData[j].textContent.length,
              });
            }
          }

          // console.log(tempData);
          // console.log("Text : -" + data[i].textContent);
        }
        let htmlData = "";
        if (
          this.state.system.isOffline == true &&
          this.state.system.settings.vendor_app_menu.hasOwnProperty(
            "offline"
          ) &&
          this.state.system.settings.vendor_app_menu.offline.status == 1
        ) {
          htmlData = Object.keys(billData)
            .map(function(k) {
              let convert = "";
              if (billData[k].size == 1) {
                convert = billData[k].content;
                convert = convert.toString();
              } else {
                convert = billData[k].content.substr(
                  0,
                  billData[k].content.length
                );
                convert = convert + "\x0A";
                convert = convert.toString();
              }
              return convert;
            })
            .join("");
        } else {
          htmlData = Object.keys(billData)
            .map(function(k) {
              let convert = "";
              if (billData[k].size == 1) {
                convert = billData[k].content;
                convert = convert.toString();
              } else {
                convert = billData[k].content.substr(
                  0,
                  billData[k].content.length - 1
                );
                convert = convert + "\x0A";
                convert = convert.toString();
              }
              return convert;
            })
            .join("");
        }

        // console.log(billData);
        // console.log(htmlData.toString());
        let config = "";
        // let smallFont = "\x1b" + "\x21" + "\x03";
        let centerAlign = "\x1B" + "\x61" + "\x31";
        let oneLineBreak = this.billLogo.data[0].data != "" ? "\x0A" : "";
        let paperCut = !this.qrCode.print ? "\x1D" + "\x56" + "\x30" : "";
        let lineBreak = !this.qrCode.print ? "\x0A" + "\x0A" + "\x0A" : "\x0A";
        // let openCashDrawer = "\x10" + "\x14" + "\x01" + "\x00" + "\x05";
        let pdata = [];
        if (this.printSize == "A4") {
          var Pixeldata = [
            {
              type: "pixel",
              format: "html",
              flavor: "plain", // or 'plain' if the data is raw HTML
              data:
                "<html><head>" +
                this.state.billing.billing.invoice.data.html_data.style +
                "</head><body>" +
                this.state.billing.billing.invoice.data.html_data.html +
                "</body></html>",
            },
          ];
          config = qz.configs.create(this.state.system.printer, {
            units: "mm",
            margins: 6,
          });
          pdata = Pixeldata;
        } else {
          config = qz.configs.create(this.state.system.printer, {
            units: "mm",
          });
          if (this.state.system.printer == "TP 3260" || this.state.system.printer == "RETSOL TP806")
            pdata = [
              centerAlign +
                oneLineBreak +
                htmlData +
                lineBreak +
                lineBreak +
                paperCut,
            ];
          else
            pdata = [
              centerAlign + oneLineBreak + htmlData + lineBreak + paperCut,
            ];
        }
        // console.log(htmlData);
        // console.log(pdata);
        if (this.printSize == "A4" || this.billLogo.data[0].data == "")
          qz.print(config, pdata).then(() => {
            if (this.qrCode.print)
              qz.print(this.qrCode.config, this.qrCode.data);
          });
        else
          qz.print(this.billLogo.config, this.billLogo.data).then(() =>
            qz.print(config, pdata).then(() => {
              if (this.qrCode.print)
                qz.print(this.qrCode.config, this.qrCode.data);
            })
          );
        if (this.state.billing.bill_print_limit.enable) this.printBtn = 1;
        // console.log(data);
      });
      // let billData = [];

      // let htmlData = "";
      // htmlData = Object.keys(billData)
      //   .map(function(k) {
      //     return billData[k].content.toString();
      //   })
      //   .join("");
      // console.log(billData);

      // Get default printer
      // qz.printers.getDefault().then(data => {
      //   this.defaultPrinter = data;
      // });
      // let self = this;
      // let printerConfig = {
      //   colorType: "blackwhite",
      //   copies: 1,
      //   margins: "0",
      //   rasterize: "false",
      //   rotation: "0",
      //   scaleContent: "false",
      //   units: "mm"
      // };
      // let config = qz.configs.create(this.state.system.printer, printerConfig);
      // let options = {
      //   language: "ESCP"
      // };
      // let size = 11;
      // // Paper width 8 cm
      // let defaultStyle =
      //   "<style>* { font-size: 10px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table {width:280px;  margin-left: -70px; margin-right:0px;  } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; margin-left:-10px } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:0px !important; } tbody { display: table !important; }</style>";
      // if (this.printSize == 58) {
      //   // Paper width 5 cm
      //   size = 10;
      //   defaultStyle =
      //     "<style>* { font-size: 9px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table { width:100px;  margin-left:-90px; margin-right:5px } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:15px !important; } tbody { display: table !important; width: inherit; word-wrap: break-word; }</style>";
      // }
      // let data = [
      //   {
      //     type: "raw",
      //     format: "html",
      //     flavor: "plain", // or 'plain' if the data is raw HTML
      //     // data: this.state.billing.invoice.data.html_data,
      //     data:
      //       "<html><body>" +
      //       defaultStyle +
      //       this.state.billing.invoice.data.html_data +
      //       "</body></html>"
      //     // data:
      //     //   '<html><body><style>* { font-size: 10px; white-space: pre-wrap; }</style><table style="border:1px solid black"><tr><td style="font-size:13px"><b><pre>Pos Store -1\n</pre></b></td></tr><tr><t d style="font-size:12px"><span><pre>D-3 Phase-II Opp Lajpat Nagar Police Station Cool School\n</pre></span></t></tr></table></body></html>'
      //   }
      // ];
      // // console.log(config);
      // qz.print(config, data)
      //   .then(function() {
      //     self.invoiceBtnDisabled = true;
      //     console.log("Sent data to printer");
      //   })
      //   .catch(function(e) {
      //     console.error(e);
      //   });
      // console.log("Default Printer : - " + this.defaultPrinter);
    },
    printAcknowledgement() {
      let data = {
        trans_from: this.state.system.trans_from,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        c_id: this.state.billing.billing.customer.data.c_id,
        vu_id: this.state.sessions.user.vu_id,
        operation: "BILL_REPRINT", // BILL_PRINT , BILL_REPRINT
        invoice_id: this.order_id,
        url: "/print_ack",
        security_code_vu_id: "", //Send this only on reprint
      };
      let postdata = Object.assign(
        data,
        this.essentialsData,
        this.customerData
      );
      axios.post(data.url, postdata).then(() => {
        console.log("print ack");
      });
    },
    openDepositModal() {
      // this.layby_amt_due = this.state.billing.invoice.summary.total_payable;
      console.log("[Deposit-Amount]");
      this.$refs["deposit-amount"].show();
    },
    SaveDepositAmt() {
      this.$loading = true;
      console.log("layby");
      var postdata = {
        // c_id: this.state.c_id,
        order_id: this.state.billing.billing.invoice.data.order_id,
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        // udidtoken: this.state.system.trans_from,
        trans_from: this.state.system.trans_from,
        url: "/vendor/process-lay-by",
      };
      let data = Object.assign(
        postdata,
        this.essentialsData,
        this.customerData
      );
      axios
        .post(postdata.url, data)
        .then((response) => {
          this.$loading = false;
          this.$store.commit("billing/saveOrder", response.data);
          this.$store.commit(
            "billing/getTotalPayable",
            parseInt(this.layby_amt_due)
          );
          this.$store.commit(
            "billing/saveLaybyAmount",
            parseFloat(this.layby_amt_due)
          );
          this.$store.commit("billing/clearInvoiceData");
          this.$emit("deposit");
        })
        .catch(() => (this.$loading = false));
    },
    generateEinvoice() {
      this.eInvoiceStatus = "";
      this.$store
        .dispatch("billing/generateEinvoice")
        .then(async (res) => {
          if (res.data.status == "error") this.eInvoiceStatus = "fail";
          else {
            await this.fetchInfo();
            this.eInvoiceStatus = "success";
            let temp = 9;
            this.eInvoiceTimer = setInterval(() => {
              if (temp != 0)
                document.getElementById("timer").innerText = temp--;
              else this.$refs["einvoice-modal"].hide();
            }, 1000);
          }
          if (document.getElementById("einvoice-modal") == null) {
            this.$refs["einvoice-modal"].show();
            if (document.getElementById("print-confirmation-modal") != null)
              this.$refs["print-confirmation-modal"].hide();
          }
        })
        .catch((err) => {
          // if (err.response.data.status == "error")
          this.eInvoiceStatus = "fail";
          if (document.getElementById("einvoice-modal") == null) {
            this.$refs["einvoice-modal"].show();
            if (document.getElementById("print-confirmation-modal") != null)
              this.$refs["print-confirmation-modal"].hide();
          }
        });
    },
    eInvoiceHandler() {
      if (this.eInvoiceStatus == "fail") this.generateEinvoice();
      this.$refs["einvoice-modal"].show();
    },
    clearTimer() {
      clearInterval(this.eInvoiceTimer);
    },
    checkForPrint() {
      if (
        this.state.billing.bill_print_limit.enable &&
        this.state.billing.bill_print_limit.count ==
          this.state.billing.bill_print_limit.limit
      ) {
        this.$emit("printLimitExceeded", "print_limit");
        return;
      }
      if (
        !this.state.system.isOffline &&
        this.state.billing.billing.invoice.data.hasOwnProperty("cust_gstin") &&
        JSON.parse(this.state.system.settings.store.einvoice_enable) &&
        this.state.billing.billing.invoice.data != null &&
        this.eInvoiceStatus != "success"
      )
        this.$refs["print-confirmation-modal"].show();
      else if (
        !this.state.system.isOffline &&
        this.state.billing.billing.invoice.data.hasOwnProperty("cust_gstin") &&
        JSON.parse(this.state.system.settings.store.einvoice_enable) &&
        this.state.billing.billing.invoice.data != null &&
        this.eInvoiceStatus == "success"
      )
        this.openPrintModal();
      else this.openPrintModal();
    },
  },
};
</script>
<style lang="scss" scoped>
.checkout .summary-height-tax {
  height: calc(100vh - 211px) !important;
}
.checkout .summary-height {
  height: calc(100vh - 162px) !important;
}
.checkout .payment-methods {
  // height: calc(100vh - 162px) !important;
  // height: calc(100vh - 211px) !important;
  h6 {
    font-size: 0.8125rem;
    color: #808080;
  }
  img {
    height: 44px;
  }
  label {
    padding-left: 0;
    color: #808080 !important;
  }
  .text-success {
    color: #33cf6c !important;
  }
}
.grey-outline-btn {
  border: 1px #808080 solid;
  background-color: transparent !important;
  color: #808080 !important;
  width: 90px;
}
.grey-outline-btn:focus:active {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff;
}
.grey-outline-btn:hover {
  border: 1px #808080 solid;
  background-color: #808080 !important;
  color: #fff !important;
}
.grey-btn:hover {
  border: 1px #808080 solid;
}
.grey-btn:active {
  border: 1px #808080 solid;
}
.grey-btn {
  border: 1px #808080 solid;
  padding: 0.675rem 1rem !important;
  color: #fff;
  width: 120px !important;
}
.btn:hover {
  color: #fff;
}
#__BVID__25___BV_modal_body_ .modal-head {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
}
.theme-dark #cool .modal-head .modal-title {
  color: #fff !important;
}

.modal-body .step-1 h6 {
  font-size: 0.875rem;
  margin: 0px;
  font-weight: 500;
}
.theme-dark .modal-body .step-1 h6 {
  color: #fff;
}
.modal-body input[type="email"]:focus {
  background: #fff;
  border: 1px #000 solid !important;
}
.theme-dark .modal-body input[type="email"]:focus,
.theme-dark .modal-body input[type="number"]:focus {
  background: #000 !important;
  border: 2px #404040 solid !important;
}
.modal-body .step-2 ul {
  text-align: center;
  padding: 0px;
  li {
    list-style-type: none;
    padding-bottom: 10px;
    p {
      color: #404040;
    }
  }
  li + li {
    padding-bottom: 0px;
  }
}
.theme-dark .modal-body .step-2 ul {
  li p {
    color: #c0c0c0;
  }
}
.modal-body .fa-times {
  font-weight: 400;
  cursor: pointer;
}
</style>
